import { render, staticRenderFns } from "./IconBadge.vue?vue&type=template&id=2c0ce828"
import script from "./IconBadge.vue?vue&type=script&lang=js"
export * from "./IconBadge.vue?vue&type=script&lang=js"
import style0 from "./IconBadge.vue?vue&type=style&index=0&id=2c0ce828&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports